module.exports = __webpack_public_path__ + "static/media/CheckBoxInactiveRed.2fe93bcc.svg";